const FavoriteType = {
    HOME: "HOME",
    WORK: "WORK",
    OTHER: "OTHER"
}

export default FavoriteType;
